import ExpenseSubServices from "@/services/ExpenseSubServices.js";
import ReportServices from "@/services/ReportServices.js";
import WarehouseServices from "@/services/WarehouseServices.js";

export default {
  getSubCatList: ExpenseSubServices.getList,
  getProfitLoss: ReportServices.getProfitLoss,
  getWarehouseList: WarehouseServices.getList,
}